import React, { useEffect } from 'react'

import PoliciesLargeButton from '../candidates/components/PoliciesLargeButton'
import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'
import { CircularProgressbar } from 'react-circular-progressbar'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'
import { useQuery } from 'react-query'
import { getPolicyAgreement } from './apiCalls'
import { User } from './apiCalls'
import {
  // getPolicyType,
  getPolicyTypeSCR,
  policiesAgreement,
} from '../../utils/types'

const Policies = ({ data }: { data?: User }) => {
  const policiesAgreement = useQuery('Agreements', () =>
    getPolicyAgreement(data?.schoolId || '', data?.userId)
  )

  useEffect(() => {
    policiesAgreement.refetch()
  }, [])

  function containsPolicyId(data: policiesAgreement[], id: string): boolean {
    if (!Array.isArray(data)) {
      throw new Error('Input data must be an array')
    }

    // Check if the id exists in the array of policyIds
    return data.some((item) => item?.policyId === id)
  }
  const policyAgreementIds = policiesAgreement?.data?.map((item) => {
    return item?.policyId
  })

  function calculateCommonIdsPercentage(
    arrayOfObjects: getPolicyTypeSCR[],
    policyAgreementIds: string[]
  ): { percentage: number; color: string } {
    let percentage: number
    let color: string
    if (policyAgreementIds.length == 0) {
      percentage = 0
      color = 'red'
    } else {
      const objectIds = arrayOfObjects?.map((obj) => obj.policyId)

      // Step 2: Check for common ids
      const commonIds = objectIds?.filter((policyId) =>
        policyAgreementIds?.includes(policyId)
      )

      // Step 3: Calculate percentage
      percentage = (commonIds?.length / arrayOfObjects?.length) * 100

      if (percentage >= 95) {
        color = '#01B38B'
      } else if (percentage >= 40) {
        color = '#FFA800'
      } else {
        color = '#FF6666'
      }
    }

    return { percentage, color }
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <div className="flex my-8 gap-2">
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {/* {policiesData?.isLoading && (
            <div className="flex-col h-[400px] w-[100%] p-[10px]">
              <Loading size="medium" />
            </div>
          )} */}
          {data?.Policies?.map((item, index) => (
            <PoliciesLargeButton
              key={index}
              title={item.title}
              icon="IconFileCheckInActive"
              iconStrokeWidth={1.5}
              iconSize={24}
              rightIcon={'IconDownloadCloud'}
              ButtonStyle={{ height: 62 }}
              badgeColor={
                containsPolicyId(policiesAgreement.data || [], item.policyId) ==
                true
                  ? 'bg-[#CCF0E8]'
                  : 'bg-[#FFD8D8]'
              }
              bagdeLabel={
                containsPolicyId(policiesAgreement.data || [], item.policyId) ==
                true
                  ? 'Agreed'
                  : 'Not Agreed'
              }
            />
          ))}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm text-bluishGreen flex-1 font-semibold'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={Number(
                      calculateCommonIdsPercentage(
                        data?.Policies as getPolicyTypeSCR[],
                        policyAgreementIds || []
                      ).percentage.toFixed(0)
                    )}
                    text={`${Number(calculateCommonIdsPercentage(data?.Policies as getPolicyTypeSCR[], policyAgreementIds || []).percentage.toFixed(0))}%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: calculateCommonIdsPercentage(
                          data?.Policies as getPolicyTypeSCR[],
                          policyAgreementIds || []
                        ).color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <Accordion defaultActiveIndex={0}>
                  <AccordionItem
                    title={'Your score is broken down as follows:'}
                    isActive={false}
                    AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                    AccordiontitleStyle={
                      'text-xs font-semibold text-text4 leading-5 flex-1'
                    }
                    AccordionItemStyleContainer={{
                      backgroundColor: '#FFFFFF',
                    }}
                  >
                    <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                      {data?.Policies?.map((item, index) => (
                        <div key={index} className="mt-3">
                          <UIStaightlineProressBar
                            percentage={
                              containsPolicyId(
                                policiesAgreement.data || [],
                                item.policyId
                              ) == true
                                ? 100
                                : 0
                            }
                            label={item.title}
                            stroke={
                              containsPolicyId(
                                policiesAgreement.data || [],
                                item.policyId
                              ) == true
                                ? '#01B38B'
                                : ''
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                      ))}
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  )
}

export default Policies
